import React from 'react';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { PlanStatus } from '../../../domain/plan/PlanStatus';

export const colorByPlanStatus = {
  finished: RoutalPalette.success,
  planning: RoutalPalette.secondary20n,
  in_progress: RoutalPalette.secondary40,
  draft: RoutalPalette.secondary20n,
} as Record<PlanStatus, string>;

type PlanStatusIconProps = {
  status: PlanStatus;
  style?: React.CSSProperties;
};

export const PlanStatusIcon = ({ status, style }: PlanStatusIconProps) => (
  <div
    style={{ width: `12px`, height: `12px`, borderRadius: `50%`, ...style, backgroundColor: colorByPlanStatus[status] }}
  />
);
